import React, { Fragment } from 'react'
import './assets/css/CovihackMPrizes.css'
import MPrize_card from './MPrize_card'
import one from './assets/CoviHack Page assets/prizes/one.jpeg'
import two from './assets/CoviHack Page assets/prizes/two.jpeg'

const Covihack_MPrizes = () => {
    return (
        <Fragment>
            <div className="mprizes my-3">
                <div className="container">
                    <h1 className="text-center prheading">PRIZES for each TRACK</h1>
                    <div className="row">
                        <MPrize_card im={one} tag="1st">
                            <ul>
                                <li>Rs. 2000</li>
                                <li><span>BludB</span> - Goodies</li>
                                <li><span>Taskade</span> - Lifetime upgrades for winners
                                    - 1-Year free upgrades</li>
                                <li><span>echo3D</span> - premium tier services as a free perk and resource to all participants</li>
                                <li><span>Interview Cake</span> - Full Coding interview prep course</li>
                                <li><span>xyz</span> - Free domains for creating website</li>
                                
                            </ul>
                        </MPrize_card>
                   
                        <MPrize_card im={one} tag="2nd">

                            <ul>
                                <li>Rs. 1000</li>
                                <li><span>BludB</span> - Vouchers</li>
                                <li><span>Taskade</span> - Lifetime upgrades for winners
                                    - 1-Year free upgrades</li>
                                <li><span>echo3D</span> - premium tier services as a free perk and resource to all participants</li>
                                <li><span>Interview Cake</span> - Full Coding interview prep course</li>
                                <li><span>xyz</span> - Free domains for creating website</li>
                            </ul>
                        </MPrize_card>

                        <div className="col-lg-4 col-md-4 my-2">
                    <div className="onecard">
                    <div className="card">
                        <div className="row">
                            <div className="col-md-11">
                                <div className="two">
                                    <div >
                                        <h1 className="participation-tag">All Participants</h1>
                                        <div className="prize-list mt-5">
                                        <ul>
                                        <li><span>Taskade</span> - Lifetime upgrades for winners
                                    - 1-Year free upgrades</li>
                                <li><span>echo3D</span> - premium tier services as a free perk and resource to all participants</li>
                                <li><span>Interview Cake</span> - Full Coding interview prep course</li>
                                <li><span>xyz</span> - Free domains for creating website</li>
                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>

                    </div>
                    <div className='row'>
                        <div className='col-sm-12'>
                            <div className="spec-card">
                                <div className="row">
                                    <div >
                                    <h1  className="heading">Additional prize - The most challenging prototype [Only for TRACK 2]</h1>
                                    </div>
                                    <div className="col-md-11">
                                        <div className="two">
                                            <div >
                                                <div className="pr">
                                                    Cash prize of Rs 1000
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default Covihack_MPrizes
